import React from "react";
import { CircleCheckIcon } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { BookCover } from "./BookCover";
import { OfferLink } from "./OfferLink";
import { collectionBenefits, volumes } from "../data/landing";
import { offer } from "../data/offer";
export function VolumesSection() {
  return <section className="bg-white" data-id="element-313" data-mp="7qpoq0aw0npn">
      <div className="mx-auto max-w-6xl px-5 py-16 md:py-24" data-id="element-314" data-mp="7nldwk2x2tq0">
        <SectionHeading eyebrow="The Complete Collection" title={<>
              Discover What's Inside <span className="text-royal" data-id="element-316" data-mp="3c4xlqay6imnj">WHY WE BELIEVE.</span>
            </>} subtitle={<p data-id="element-317" data-mp="3pvaugfiwa5dx">Six carefully organized digital volumes covering the questions Christian parents care about most.</p>} data-id="element-315" data-mp="3g613x43p8urx" />

        <ul className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-318" data-mp="3l39jcwxgqkph">
          {volumes.map(v => <li key={v.number} className="flex flex-col overflow-hidden rounded-3xl bg-canvas ring-1 ring-ink/5" data-id="element-319" data-mp="2xdop3hvv010w">
              <div className="px-6 pt-8" style={{
            backgroundColor: `${v.color}1A`
          }} data-id="element-320" data-mp="2sevnampxpygk">
                <div className="mx-auto flex aspect-[3/4] w-[52%] translate-y-6 items-end" data-id="element-321" data-mp="29ez3vx1qmi0r">
                  {v.cover ? <img src={v.cover} alt={`Volume ${v.number} cover: ${v.title}`} loading="lazy" className="h-auto w-full rounded-lg shadow-[0_18px_32px_-14px_rgba(11,24,56,0.55)]" data-id="element-322" data-mp="2ecqxcvi16c72" /> : <BookCover kicker={`Volume ${v.number}`} title={v.title} color={v.color} icon={v.icon} className="w-full" data-id="element-323" data-mp="2o3d5y5rby2g9" />}
                </div>
              </div>
              <div className="flex flex-1 flex-col p-6 pt-10" data-id="element-324" data-mp="1vfpmiu1sphv7">
                <p className="font-display text-xs font-extrabold uppercase tracking-[0.16em]" style={{
              color: v.color
            }} data-id="element-325" data-mp="1vfzicy9iuj8t">
                  Volume {v.number}
                </p>
                <h3 className="mt-1.5 font-display text-xl font-extrabold leading-tight text-ink" data-id="element-326" data-mp="24hqizop7fzvt">{v.title}</h3>
                <p className="mt-2 leading-relaxed text-ink-soft" data-id="element-327" data-mp="3bwbsu1bspgz3">{v.text}</p>
              </div>
            </li>)}
        </ul>

        <div className="mt-14 rounded-[2rem] bg-royal-light px-6 py-10 md:px-12" data-id="element-328" data-mp="1gqknldk6xcsh">
          <ul className="mx-auto flex max-w-4xl flex-wrap justify-center gap-3" data-id="element-329" data-mp="1brq4sbm83o8d">
            {collectionBenefits.map(b => <li key={b} className="flex items-center gap-2 rounded-full bg-white px-4 py-2.5 text-[15px] font-semibold text-navy" data-id="element-330" data-mp="1pr8xpx6gqt03">
                <CircleCheckIcon className="h-5 w-5 shrink-0 text-leaf" strokeWidth={2.25} aria-hidden="true" data-id="element-331" data-mp="1ktplt3x8msbb" />
                {b}
              </li>)}
          </ul>
          <div className="mx-auto mt-8 max-w-md" data-id="element-332" data-mp="t1i6c6tgxlyi">
            <OfferLink label={`Get My Complete Bundle for ${offer.price}`} data-id="element-333" data-mp="t2t9q5j04rp3" />
          </div>
        </div>
      </div>
    </section>;
}